// extracted by mini-css-extract-plugin
module.exports = {"Jersey":"Jersey_Jersey___XOKw"};